import { Chip } from "@mui/material";
import { toast } from "react-toastify";

export default function BetaPill({ message, fontSize = "0.65" }) {
  const handleClick = () => {
    toast.info(message, { autoClose: false });
  };
  return (
    <Chip
      variant="outlined"
      onClick={message ? handleClick : undefined}
      clickable={Boolean(message)}
      label="BETA"
      size="small"
      sx={{
        borderRadius: 1,
        "& .MuiChip-label": {
          fontSize: `${fontSize}rem`,
          color: (theme) => theme.palette.text.disabled,
          p: 0.5,
        },
      }}
    />
  );
}
